var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-wrapper"},[_c('div',{staticClass:"calculator"},[_c('CalculatorHeading',{attrs:{"step":_vm.step}}),_c('SelectInput',{attrs:{"question":_vm.$t('mobile-app.question'),"selections":[
        {
          image: require('@/assets/empty.svg'),
          name: _vm.$t('mobile-app.none'),
          value: 'none'
        },
        {
          image: require('@/assets/ios-only.svg'),
          name: _vm.$t('mobile-app.apple'),
          value: 'apple'
        },
        // {
        //   image: require('@/assets/android-only.svg'),
        //   name: $t('mobile-app.android'),
        //   value: 'android'
        // },
        {
          image: require('@/assets/android-ios.svg'),
          name: _vm.$t('mobile-app.both'),
          value: 'both'
        } ],"selected-value":_vm.mobileApp,"clicked-callback":_vm.onSelect}}),_c('a',{staticClass:"back-btn",on:{"click":function($event){_vm.$router.push(_vm.getPrevStepUrl(_vm.step, _vm.$i18n.locale))}}},[_vm._v(_vm._s(_vm.$t('back')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }